import Vue from "vue"
import VueTouch from "vue-touch"
import VueApexCharts from "vue-apexcharts"
import App from "./App"
import router from "./router/index"
import store from "./store/index"
import "./registerServiceWorker"

Vue.use(VueTouch)
Vue.use(VueApexCharts)

Vue.component("apexchart", VueApexCharts)

// FontAwesome import
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faHome,
	faUserChart,
	faTrophy,
	faBeer,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAngleDoubleUp,
	faAngleDown,
	faAngleDoubleDown,
	faUser,
	faChartLine,
	faHandScissors,
	faMeh,
	faQuestionCircle,
	faCouch,
} from "@fortawesome/pro-regular-svg-icons"
import { faBomb, faTrophy as faTrophySolid } from "@fortawesome/free-solid-svg-icons"

library.add(faAngleLeft)
library.add(faAngleRight)

// mobile nav menu
library.add(faHome)
library.add(faUserChart)
library.add(faTrophy)
library.add(faBeer)
library.add(faUser)
library.add(faQuestionCircle)

// standings up/down arrows
library.add(faAngleUp)
library.add(faAngleDoubleUp)
library.add(faAngleDown)
library.add(faAngleDoubleDown)

// quick stat icons
library.add(faChartLine)
library.add(faBomb)
library.add(faHandScissors)
library.add(faMeh)
library.add(faCouch)

// league winner icon
library.add(faTrophySolid)

Vue.component("font-awesome-icon", FontAwesomeIcon)

// Bulma overrides
require("@/assets/scss/main.scss")

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app")
